import ActionTypes from '../constants/ActionTypes';

export function changePasswordView() {
  return { type: 'CHANGE_PASSWORD_VIEW' };
}

export function changeTickView() {
  return { type: 'CHANGE_Tick_VIEW' };
}

export function changeProductListView(data) {
  return {
    type: 'CHANGE_PRODUCT_LIST_VIEW',
    data
  };
}

export function changeReviewStarRating(data) {
  return {
    type: 'CHANGE_REVIEW_STAR_RATING',
    data: data
  };
}
/* Mod-prodcut */

export function changeProductQuantity(data) {
  return {
    type: 'CHANGE_PRODUCT_QUANTITY',
    data: data
  };
}

/* Mod-search */

export function closeSearchPopup(data) {
  return {
    type: 'CLOSE_SEARCH_POPUP',
    data: data
  };
}

export function changeSearchBarView(data) {
  return {
    type: 'CHANGE_SEARCH_BAR_VIEW',
    data: data
  };
}

/* Mod-search-result */

export function changeSearchText(data) {
  return {
    type: 'CHANGE_SEARCH_TEXT',
    data
  };
}

/* 改变筛选结果 */
export function changeFilterText(data, index) {
  return {
    type: 'CHANGE_FILTER_TEXT',
    data,
    index
  };
}

/* 删除筛选结果 */
export function delFilterText(data, index, parentKey) {
  return {
    type: 'DELETE_FILTER_TEXT',
    data,
    index,
    parentKey
  };
}

/* 改变筛选框父级状态 */
export function changeFilterItemState(data, isFilter) {
  return {
    type: 'CHANGE_ITEM_STATE',
    data,
    isFilter
  };
}

/* 改变个人中心子菜单状态 */
export function changeSubMenuState(data) {
  return {
    type: 'CHANGE_SUB_MENU_STATE',
    data
  };
}

/* 移动端 筛选浮层滑进 */
export function openFilterBar() {
  return {
    type: 'OPEN_FILTER_BAR'
  };
}

/* 移动端 筛选浮层滑出 */
export function closeFilterBar() {
  return {
    type: 'CLOSE_FILTER_BAR'
  };
}

/* 改变联系商家状态 */
export function changeContactState(data) {
  return {
    type: 'CHANGE_CONTACT_STATE',
    data
  };
}

/* 切换库存图片 */
export function changeProdImg(index) {
  return {
    type: 'CHANGE_PROD_IMG',
    index
  };
}

/* 联系商家 */
export function contactSellerState(mobile, email) {
  return {
    type: 'CONTACT_SELLER',
    mobile,
    email
  };
}

/* 获取焦点改变error状态 */
export function changeErrorState() {
  return {
    type: 'CHANGE_ERROR_STATE'
  };
}

/* 关闭联系成功提示框 */
export function closeSuccessWrap() {
  return {
    type: 'CLOSE_SUCCESS_WRAP'
  };
}

/* 倒计时结束 */
export function countdownStop() {
  return {
    type: 'COUNTDOWN_STOP'
  };
}

/* 点击回复 */
export function clickReply(commentId) {
  return {
    type: 'CLICK_REPLY',
    commentId
  };
}

export function initI18n(lang) {
  lang = lang || 'en';
  return {
    type: ActionTypes.INIT_I18N,
    lang: lang
  };
}

export function changeDynamicState() {
  return {
    type: 'CHANGE_DYNAMIC_STATE'
  };
}

export function clearDynamicState() {
  return {
    type: 'CLEAR_DYNAMIC_STATE'
  };
}

export function openDialogModal(infos) {
  return {
    type: 'OPEN_DIALOG_MODAL',
    infos
  };
}

export function closeDialogModal() {
  return {
    type: 'CLOSE_DIALOG_MODAL'
  };
}

export function openDynamicModal(infos) {
  return {
    type: 'OPEN_DYNAMIC_MODAL',
    infos
  };
}

export function closeDynamicModal() {
  return {
    type: 'CLOSE_DYNAMIC_MODAL'
  };
}

export function openVerifyPartnerModal() {
  return {
    type: 'OPEN_VERIFYPARTNER_MODAL'
  };
}

export function closeVerifyPartnerModal() {
  return {
    type: 'CLOSE_VERIFYPARTNER_MODAL'
  };
}

export function openEmployeeJoinModal() {
  return {
    type: 'OPEN_EMPLOYEEJOIN_MODAL'
  };
}

export function closeEmployeeJoinModal() {
  return {
    type: 'CLOSE_EMPLOYEEJOIN_MODAL'
  };
}

export function openStockInModal() {
  return {
    type: 'OPEN_STOCKIN_MODAL'
  };
}

export function closeStockInModal() {
  return {
    type: 'CLOSE_STOCKIN_MODAL'
  };
}

export function openQtyReviseModal() {
  return {
    type: 'OPEN_QTY_REVISE_MODAL'
  };
}

export function closeQtyReviseModal() {
  return {
    type: 'CLOSE_QTY_REVISE_MODAL'
  };
}

export function openWorkflowApproveModal() {
  return {
    type: 'OPEN_WORKFLOW_APPROVE_MODAL'
  };
}

export function closeWorkflowApproveModal() {
  return {
    type: 'CLOSE_WORKFLOW_APPROVE_MODAL'
  };
}

export function openDownloadModal() {
  return {
    type: 'OPEN_DOWNLOAD_MODAL'
  };
}

export function closeDownloadModal() {
  return {
    type: 'CLOSE_DOWNLOAD_MODAL'
  };
}

export function showConfirmModal() {
  return {
    type: 'SHOW_CONFIRM_MODAL'
  };
}
